import { Navigate, useRoutes } from 'react-router-dom';
import { lazy } from 'react';
import { useAppSelector } from '../redux/hooks';

const Login = lazy(() => import('../views/login/Login'));
const Dashboard = lazy(() => import('../views/dashboard/Dashboard'));
const RoomRundown = lazy(() => import('../views/room/RoomRundown'));
const RoomInfo = lazy(() => import('../views/room/RoomInfo'));
const RoomEdit = lazy(() => import('../views/room/RoomEdit'));

function AppRoutes() {
	const loggedIn = useAppSelector((state) => state.authentication.loggedIn);

	return useRoutes([
		{
			path: '/login',
			element: loggedIn ? <Navigate replace to="/dashboard" /> : <Login />,
		},
		{ path: '/dashboard', element: loggedIn ? <Dashboard /> : <Navigate replace to="/login" /> },
		{
			path: '/room',
			element: loggedIn ? <RoomRundown /> : <Navigate replace to="/login" />,
			children: [
				{
					path: ':roomId',
					index: true,
					element: loggedIn ? <RoomInfo /> : <Navigate replace to="/login" />,
				},
				{
					path: ':roomId/edit',
					element: loggedIn ? <RoomEdit /> : <Navigate replace to="/login" />,
				},
			],
		},
		{ path: '*', element: <Navigate to="/dashboard" replace /> },
	]);
}

export default AppRoutes;
